// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Xr84","icon":"styles_icon__33DA1"};